import React from "react";
import TableBody from "./components/table-body";
import TableHead from "./components/table-head";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { NavLink } from "react-router-dom";
import { classNames } from "primereact/utils";
import { Divider } from "primereact/divider";
import "./Style.css";
import Button from "../button";
import { formatDate } from "../../../algorithms/date";
function convert12HourToEpoch(timeString) {
  const [hours, period] = timeString.match(/\d+|[APMapm]{2}/g);
  const adjustedHours =
    period.toLowerCase() === "pm" && hours !== "12" ? +hours + 12 : +hours % 12;
  return new Date().setHours(adjustedHours, 0, 0, 0);
}
function convertEpochTo12Hour(epoch) {
  const dateObj = new Date(epoch);
  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();

  // Calculate AM/PM and adjust hours
  const period = hours >= 12 ? "PM" : "AM";
  const adjustedHours = hours % 12 || 12;

  // Format the time as 'h:mm AM/PM'
  const timeString = `${adjustedHours}:${minutes
    .toString()
    .padStart(2, "0")} ${period}`;

  return timeString;
}
function createTimeRange(time) {
  const startEpoch = convert12HourToEpoch(`${time} AM`);
  const endEpoch = convert12HourToEpoch(`${time} PM`);

  const startTime = convertEpochTo12Hour(startEpoch);
  const endTime = convertEpochTo12Hour(endEpoch).replace(":00", ":59");

  return `${startTime} to ${endTime}`;
}
export default function Table({
  className,
  headers = [
    {
      header_name: "Column 1",
      header_key: "column1",
      tag: "date",
    },
    {
      header_name: "Column 2",
      header_key: "column2",
    },
  ],
  items = [
    {
      column1: "Column 2",
      column2: "Column 2",
    },
  ],
  isNative = false,
  children,
  linkName,
  linkBody,
  fieldId,
  actionColumn,
  bottomAction,
  multiItemField,
  id,
  dt,
  actionEdit,
  actionView,
  notSortableColumn = "",
  isForPackageHistory = false,

  actionEvent = () => {},
}) {
  const withLinkTemplate = (rowData) => {
    if (Array.isArray(fieldId)) {
      return (
        <a
          className={"text-component-blueTextColor"}
          href={`${process.env.REACT_APP_BASE_ENVIRONMENT}${linkBody}/${
            rowData[fieldId[0]]
          }/${rowData[fieldId[1]]}`}
          target="_blank"
        >
          {rowData[linkName]}
        </a>
      );
    } else {
      return (
        <a
          className={"text-component-blueTextColor"}
          href={`${process.env.REACT_APP_BASE_ENVIRONMENT}${linkBody}/${rowData[fieldId]}`}
          target="_blank"
        >
          {rowData[linkName]}
        </a>
      );
    }
  };

  const multiItemTemplate = (rowData) => {
    return (
      <div>
        {rowData[multiItemField] &&
          Object.values(rowData[multiItemField]).map((element) => {
            return (
              <div className="border-b-2 border-black-500">
                <p>{element}</p>
              </div>
            );
          })}
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        {actionEdit && (
          <Button
            className="p-2"
            value="Edit"
            onClick={() => actionEdit(rowData)}
          />
        )}
        {actionView && (
          <Button
            className="p-2"
            value="View"
            onClick={() => actionEvent(rowData)}
          />
        )}
      </div>
    );
  };

  const dateTemplate = (rowData, data) => {
    return <p>{formatDate(rowData[data.column.props.field].split("T")[0])}</p>;
  };

  const numberTemplate = (rowData, data) => {
    return rowData[data.column.props.field].substring(2);
  };
  const percentTemplate = (rowData, data, total) => {
    console.log(total);
    return (
      <p>
        {rowData[data.column.props.field]}% of {total}
      </p>
    );
  };
  const timeSpanTemplate = (rowData, data) => {
    return (
      <p>
        {createTimeRange(
          convertEpochTo12Hour(rowData[data.column.props.field])
        )}
      </p>
    );
  };
  return (
    <div className={`${className}`}>
      <DataTable
        paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
        currentPageReportTemplate="Rows per page"
        // currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records |  Rows per page"
        value={items}
        paginator
        paginatorRight
        rowsPerPageOptions={[10, 20, 50]}
        rows={10}
        sortMode="multiple"
        sortField="name"
        sortOrder={1}
        stripedRows
        showGridlines
        tableStyle={{
          minWidth: "50rem",
        }}
        style={{
          borderLeftWidth: 2,
          borderBottomWidth: 2,
          borderRightWidth: 2,
          borderColor: "#E6E6E6",
        }}
        removableSort
        id={id}
        ref={dt}
        cellSelection={true}
        onCellClick={(e) => {
          if (isForPackageHistory) {
            if (
              e.field == "waybillNumber" &&
              e.rowData.userId != null &&
              e.rowData.packageId != null
            ) {
              window.open(
                `/operator/admin/view-package-history/${e.rowData.packageId}/${e.rowData.userId}`,
                "_blank"
              );
            }
            if (e.field == "partnerAgentMobile") {
              // window.open(
              // 	`/operator/admin/agents/agentProfile/${e.rowData.agentId}`,
              // 	"_blank"
              // );
              if (e.rowData.agentId != null) {
                window.open(
                  `/operator/admin/agents/agentProfile/${e.rowData.agentId}`,
                  "_blank"
                );
              } else {
                // console.error(`no agent found`);
              }
            }
            if (e.field == "recipientMobile" && e.rowData.userId != null) {
              window.open(
                `/operator/admin/locker-user-accounts/user-profile-page/${e.rowData.userId}`,
                "_blank"
              );
            }
          }
        }}
      >
        {headers.map((data, key) => {
          if (linkBody && linkName === data.header_key) {
            return (
              <Column
                field={data.header_key}
                sortable
                header={data.header_name}
                body={withLinkTemplate}
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              ></Column>
            );
          }
          if (data.header_key === notSortableColumn) {
            return (
              <Column
                field={data.header_key}
                sortable={false}
                header={data.header_name}
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              ></Column>
            );
          }
          if (data.header_key === multiItemField) {
            return (
              <Column
                sortable
                header={data.header_name}
                body={multiItemTemplate}
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              ></Column>
            );
          }
          if (data.tag === "date") {
            return (
              <Column
                field={data.header_key}
                sortable
                body={dateTemplate}
                header={data.header_name}
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              ></Column>
            );
          }
          if (data.tag === "percent") {
            return (
              <Column
                field={data.header_key}
                sortable
                body={(rowData, field) =>
                  percentTemplate(rowData, field, data.total)
                }
                header={data.header_name}
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              ></Column>
            );
          }
          if (data.tag === "timeSpan") {
            return (
              <Column
                field={data.header_key}
                sortable
                body={timeSpanTemplate}
                header={data.header_name}
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              ></Column>
            );
          }
          if (data.tag === "number") {
            return (
              <Column
                field={data.header_key}
                sortable
                body={numberTemplate}
                header={data.header_name}
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              ></Column>
            );
          }
          if (data.tag == "link_mobile_agent") {
            return (
              <Column
                field={data.header_key}
                id={"link_mobile_agent"}
                sortable
                header={data.header_name}
                className="font-blue cursor-pointer font-bold"
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              ></Column>
            );
          }
          if (data.tag == "link_user_agent") {
            return (
              <Column
                id={"link_user_agent"}
                field={data.header_key}
                sortable
                header={data.header_name}
                className="font-blue cursor-pointer font-bold"
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              ></Column>
            );
          }
          if (data.tag == "link_waybill") {
            return (
              <Column
                id={"link_waybill"}
                field={data.header_key}
                sortable
                header={data.header_name}
                className="font-blue cursor-pointer font-bold"
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              ></Column>
            );
          }
          return (
            <Column
              field={data.header_key}
              sortable
              header={data.header_name}
              // className=""
              className="max-w-[200px] break-words"
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
            ></Column>
          );
        })}
        {(actionEdit || actionView) && (
          <Column
            field={"action"}
            header={""}
            body={actionBodyTemplate}
            headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
          ></Column>
        )}
      </DataTable>
    </div>
    // <>
    //   {children ? (
    //     <table className={className}>{children}</table>
    //   ) : (
    //     <table className={className}>
    //       <TableHead headers={headers} actionColumn={actionColumn} />
    //       <TableBody
    //         data={items}
    //         headers={headers}
    //         linkName={linkName}
    //         linkBody={linkBody}
    //         actionColumn={actionColumn}
    //         bottomAction={bottomAction}
    //       />
    //     </table>
    //   )}
    // </>
  );
}
